import { render } from "./GenbaDetails.vue?vue&type=template&id=2ef98232&scoped=true"
import script from "./GenbaDetails.vue?vue&type=script&lang=js"
export * from "./GenbaDetails.vue?vue&type=script&lang=js"

import "./GenbaDetails.vue?vue&type=style&index=0&id=2ef98232&scoped=true&lang=css"

import exportComponent from "/Users/asatokazu/Documents/dev/project/sms/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef98232"]])

export default __exports__